import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useSettings, buildAssetUrl } from '../contexts/SettingsContext';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { settings } = useSettings();

  const navItems = [
    { name: 'Beranda', path: '/' },
    { name: 'Jadwal', path: '/schedule' },
    { name: 'Leaderboard', path: '/leaderboard' },
    { name: 'Cek Tiket', path: '/check-ticket' },
    { name: 'Partner', path: '/partners' }
  ];

  const isActive = (path) => location.pathname === path;
  const logo = buildAssetUrl(settings?.header_logo || settings?.logo);
  const siteName = settings?.website_name?.replace(/\s*-.*/, '') || 'EXTRA TIME';
  const logoLinkUrl = settings?.logo_link_url?.trim();

  const brandInner = (
    <>
      {logo ? (
        <img src={logo} alt={siteName} className="h-10 w-auto object-contain block" />
      ) : (
        <div className="w-10 h-10 bg-gradient-to-br from-[#D90429] to-[#B00320] rounded-xl flex items-center justify-center">
          <span className="text-white font-black text-xl">ET</span>
        </div>
      )}
      <span className="text-white font-black text-lg leading-none hidden md:block">{siteName}</span>
    </>
  );

  return (
    <header className="header-sticky" data-testid="main-header">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {logoLinkUrl ? (
            <a
              href={logoLinkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 -my-1"
              data-testid="logo-link"
            >
              {brandInner}
            </a>
          ) : (
            <Link to="/" className="flex items-center gap-2 -my-1" data-testid="logo-link">
              {brandInner}
            </Link>
          )}

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.name.toLowerCase().replace(' ', '-')}`}
                className={`text-sm font-medium transition-colors ${isActive(item.path) ? 'text-[#D90429]' : 'text-gray-300 hover:text-white'}`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-white p-2" data-testid="mobile-menu-toggle">
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="lg:hidden py-4 space-y-2" data-testid="mobile-menu">
            {navItems.map((item) => (
              <Link key={item.path} to={item.path} onClick={() => setMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg transition-colors ${isActive(item.path) ? 'bg-[#D90429] text-white' : 'text-gray-300 hover:bg-white/10'}`}>
                {item.name}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};
